import React from 'react';
import PropTypes from 'prop-types';
import { useConnect, UseQueryConnect } from '@lore/query-connect';
import { BuildingOfficeIcon } from '@heroicons/react/24/outline';
import IconSection from '../../../components/IconSection';
const CACHE_TTL = 60 * 60 * 1000; // 1 hour - organizations do not change often

Organizations.propTypes = {
  user: PropTypes.object.isRequired
};

export default function Organizations(props) {
  const { user } = props;

  const jobs = useConnect('job.find', {
    where: {
      eager: {
        $where: {
          userId: user.id
        }
      }
    }, pagination: {
      page: 1, pageSize: 2, order: 'createdAt desc' // most recent organizations first
    }
  }, {cacheTime: CACHE_TTL * 2, staleTime: CACHE_TTL, refetchOnWindowFocus: false});

  const totalCount = (jobs.meta && jobs.meta.totalCount) || 0;
  const totalExtra = Math.max(0, totalCount - jobs.data.length);

  if (jobs.data.length === 0) {
    return null;
  }

  return (
    <>
      {jobs.data.map(function (job) {
        return (
          <UseQueryConnect key={job.id} _key="organization.byId" params={{id: job.data.organizationId}}>
            {function (organization) {
              return (
                <IconSection
                  icon={BuildingOfficeIcon}
                  title={job.data.title}
                  subtitle={organization.data.name}
                  xs={true}
                />
              );
            }}
          </UseQueryConnect>
        );
      })}
      {totalExtra > 0 && <p className="text-xs">+ {totalExtra} more organizations</p>}
    </>
  )
}
